__turbopack_context__.v({
  "desktopTableOnly": "BiomarkerTable-module__JfK-lG__desktopTableOnly",
  "headerText": "BiomarkerTable-module__JfK-lG__headerText",
  "hideWeb": "BiomarkerTable-module__JfK-lG__hideWeb",
  "inactive": "BiomarkerTable-module__JfK-lG__inactive",
  "infoIcon": "BiomarkerTable-module__JfK-lG__infoIcon",
  "mobileTableOnly": "BiomarkerTable-module__JfK-lG__mobileTableOnly",
  "rowBox": "BiomarkerTable-module__JfK-lG__rowBox",
  "rowText": "BiomarkerTable-module__JfK-lG__rowText",
  "thumb": "BiomarkerTable-module__JfK-lG__thumb",
  "unavailableText": "BiomarkerTable-module__JfK-lG__unavailableText",
  "wrapper": "BiomarkerTable-module__JfK-lG__wrapper",
});
